export default __webpack_public_path__ + "static/media/half-bg.43e4031e.png";